import React, { useCallback, useMemo } from "react";
import QueryHelper from "components/common/QueryHelper";
import { fetchDashboards, keyFn } from "views/components/dashboard/hooks/useDashboards";
import DashboardActions from "views/components/dashboard/DashboardsOverview/DashboardActions";
import useColumnRenderers from "views/components/dashboard/DashboardsOverview/useColumnRenderers";
import getDashboardTableElements from "views/components/dashboard/DashboardsOverview/Constants";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import usePluggableEntityTableElements from "hooks/usePluggableEntityTableElements";
import { CurrentUserStore } from "stores/users/CurrentUserStore";
import BulkActions from "./BulkActions";
const DashboardsOverview = ({ hideAdditionalColumns = false, hideShare = false, hideDelete = false }) => {
  const { pluggableColumnRenderers, pluggableAttributes, pluggableExpandedSections } = usePluggableEntityTableElements(null, "dashboard");
  const { getDefaultLayout, additionalAttributes } = getDashboardTableElements(pluggableAttributes);
  const customColumnRenderers = useColumnRenderers(pluggableColumnRenderers);
  const renderDashboardActions = useCallback(
    (dashboard) => /* @__PURE__ */ React.createElement(DashboardActions, { dashboard, hideDelete, hideShare }),
    [hideDelete, hideShare]
  );
  const expandedSections = useMemo(
    () => ({
      ...pluggableExpandedSections
    }),
    [pluggableExpandedSections]
  );
  const fetchEntities = (searchParams) => {
    CurrentUserStore.update(CurrentUserStore.getInitialState().currentUser.username);
    return fetchDashboards(searchParams);
  };
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "dashboards",
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "dashboard", commonFields: ["id", "title", "description", "summary"] }),
      entityActions: renderDashboardActions,
      tableLayout: getDefaultLayout(hideAdditionalColumns),
      fetchEntities,
      additionalAttributes,
      expandedSectionRenderers: expandedSections,
      keyFn,
      entityAttributesAreCamelCase: true,
      bulkSelection: { actions: /* @__PURE__ */ React.createElement(BulkActions, null) },
      columnRenderers: customColumnRenderers
    }
  );
};
export default DashboardsOverview;
